<script setup lang="ts">
import FooterBase from '@/views/Layout/FooterBase.vue'
import Navigation from '@/views/Layout/Navigation.vue'

interface Props {
    auth?: boolean
    gradientHeader?: boolean
}

withDefaults(defineProps<Props>(), {
    auth: false,
    gradientHeader: false,
})
</script>

<template>
    <div :class="['layout', { 'layout--auth': auth }]">
        <Navigation v-if="!auth" />
        <div class="layout__main container">
            <div v-if="gradientHeader" class="layout__header-gradient" />
            <main class="layout__content">
                <slot></slot>
            </main>
        </div>
    </div>
    <FooterBase v-if="!auth" />
</template>
